import createVueComponent from '../createVueComponent';
export default createVueComponent('outline', 'chevron-right-pipe', 'IconChevronRightPipe', [["path",{"d":"M6 6l6 6l-6 6","key":"svg-0"}],["path",{"d":"M17 5v13","key":"svg-1"}]]);